import { useState } from "react";
import { createPortal } from "react-dom";
import { useNavigate } from "react-router-dom";
import Button from "../../../components/button";
import styles from "./styles.module.css";

const MobileNavigation = ({
  showAdminBoard,
  showOpBoard,
  logOut,
  parametersSubmenu,
  complianceSubmenu,
  isActive,
  isAdminExact,
}) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const navigate = useNavigate();

  const handleNavigation = (path) => {
    setMobileMenuOpen(false);
    navigate(path);
  };

  return (
    <>
      {/* Hamburger button for mobile */}
      <button
        className={styles.hamburger}
        onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
        aria-label="Toggle menu"
      >
        <span className={styles.hamburgerLine}></span>
        <span className={styles.hamburgerLine}></span>
        <span className={styles.hamburgerLine}></span>
      </button>

      {/* Mobile menu overlay */}
      {mobileMenuOpen &&
        createPortal(
          <>
            <div
              className={styles.mobileOverlay}
              onClick={() => setMobileMenuOpen(false)}
            />
            <div className={styles.mobileMenu}>
              <ul className={styles.mobileMenuList}>
                {showOpBoard && (
                  <>
                    <li className={styles.mobileMenuSection}>
                      <span
                        className={`${styles.mobileMenuSectionTitle} ${parametersSubmenu.some((item) => isActive(item.path)) ? styles.mobileMenuSectionActive : ""}`}
                      >
                        Parámetros
                      </span>
                      {parametersSubmenu.map((item, index) => (
                        <button
                          key={index}
                          className={`${styles.mobileMenuSubItem} ${isActive(item.path) ? styles.mobileMenuItemActive : ""}`}
                          onClick={() => handleNavigation(item.path)}
                        >
                          {item.label}
                        </button>
                      ))}
                    </li>

                    <li>
                      <button
                        className={`${styles.mobileMenuItem} ${isActive("/last") ? styles.mobileMenuItemActive : ""}`}
                        onClick={() => handleNavigation("/last")}
                      >
                        Last Price
                      </button>
                    </li>
                  </>
                )}

                <li>
                  <button
                    className={`${styles.mobileMenuItem} ${isActive("/fast") ? styles.mobileMenuItemActive : ""}`}
                    onClick={() => handleNavigation("/fast")}
                  >
                    Fast Market
                  </button>
                </li>

                {showOpBoard && (
                  <li className={styles.mobileMenuSection}>
                    <span
                      className={`${styles.mobileMenuSectionTitle} ${complianceSubmenu.some((item) => isActive(item.path)) ? styles.mobileMenuSectionActive : ""}`}
                    >
                      Cumplimiento
                    </span>
                    {complianceSubmenu.map((item, index) => (
                      <button
                        key={index}
                        className={`${styles.mobileMenuSubItem} ${isActive(item.path) ? styles.mobileMenuItemActive : ""}`}
                        onClick={() => handleNavigation(item.path)}
                      >
                        {item.label}
                      </button>
                    ))}
                  </li>
                )}

                {showAdminBoard && (
                  <li>
                    <button
                      className={`${styles.mobileMenuItem} ${isActive("/logs") ? styles.mobileMenuItemActive : ""}`}
                      onClick={() => handleNavigation("/logs")}
                    >
                      Logs
                    </button>
                  </li>
                )}

                {showAdminBoard && (
                  <li>
                    <button
                      className={`${styles.mobileMenuItem} ${isAdminExact() ? styles.mobileMenuItemActive : ""}`}
                      onClick={() => handleNavigation("/admin")}
                    >
                      Gestión de Usuarios
                    </button>
                  </li>
                )}

                <li>
                  <Button
                    variant="ghost"
                    onClick={() => {
                      setMobileMenuOpen(false);
                      logOut();
                    }}
                    className={styles.mobileMenuLogout}
                  >
                    Cerrar Sesión
                  </Button>
                </li>
              </ul>
            </div>
          </>,
          document.body
        )}
    </>
  );
};

export default MobileNavigation;
